import type { SocToken } from '@/styles/tokens'

export interface MeterProps {
  value: number
  max: number
  tone?: SocToken
  label?: string
  className?: string
}

/** The 7px meter: a void trough with a token-coloured fill. */
export function Meter({ value, max, tone = 'success', label, className = '' }: MeterProps) {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0
  return (
    <div
      className={`relative w-full overflow-hidden bg-bg-deep ${className}`}
      style={{ height: 'var(--soc-meter-height)', boxShadow: 'inset 0 0 0 1px var(--soc-border)' }}
      role="meter"
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={value}
      aria-label={label}
    >
      <div
        className="absolute inset-y-0 left-0 transition-[width] duration-300"
        style={{ width: `${pct}%`, background: `var(--soc-${tone})` }}
      />
    </div>
  )
}
